import { render, staticRenderFns } from "./StoreGroupbuyingList.vue?vue&type=template&id=04c4b387&"
import script from "./StoreGroupbuyingList.vue?vue&type=script&lang=js&"
export * from "./StoreGroupbuyingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports